import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import BotoneraBottom from '../Compartidos/BotoneraBottom';
import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../Escritorio/Instrucciones';
import useConfigAuth from '../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction } from '../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../actions/almacenarEjercicioActions';
import { resetearAyudaEstadoAction } from '../../../actions/configuradorActions';

// css
import { ContainerFlex } from '../../Css/MetodosCSS/StyledLN2Todos';
import { Img } from '../../Css/StyledForm';
import { Circulo, Cuadrado} from '../../Css/MetodosCSS/StyledFonemica';
import {Flex} from '../../Css/MetodosCSS/StyledCCIntrasilabica';

const instrucciones = 'Vamos a ver un dibujo en la pantalla y vamos a tener que decir el sonido del principio y el sonido del final';
const miniInstrucciones = '';

const SCR5 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [circulos, setCirculos] = useState([]);
    const [indexes, setIndexes] = useState([]);
    const [resultado, setResultado] = useState([]);
    const [activoPrimero, setActivoPrimero] = useState(false);
    const [activoSegundo, setActivoSegundo] = useState(false);
    const [elegiPrimero, setElegiPrimero] = useState(false);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const ayuda_imagen = useSelector(state => state.configuracion.ayuda_imagen);

    const informacion = useSelector(state => state.informacion.info_DB);

    const resultadoBase = [
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""}
    ];

    const elijo = (e, nro) => {
        e.preventDefault();
        setElegiPrimero(true);
        switch (nro) {
            case 1:
                setActivoPrimero(true);
                setActivoSegundo(false);
                break;
            case 2:
                setActivoPrimero(false);
                setActivoSegundo(true);
                break;
            default:
                break;
        }
    }

    const verifico = (e, nro) => {
        e.preventDefault();
        if(!elegiPrimero) {
            return
        }
        if(comparar.ejemplo == 1) {
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.imagen_url_1;
            newList[count-1].puntaje = 0;
            newList[count-1].ayuda = false;
            newList[count-1].ejemplo = 1;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setActivoPrimero(false);
                    setActivoSegundo(false);
                    setElegiPrimero(false);
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
            return
        }
        setDisable(true);
        const newList = JSON.parse(JSON.stringify(resultado));
        newList[count-1].palabra_correcta = comparar.imagen_url_1;
        let primero;
        let segundo;
        let ayuda;
        if(activoPrimero){
            primero = 1;
        } else {
            primero = 0;
        }
        if(nro == 3){
            segundo = 1;
        } else {
            segundo = 0;
        }
        if(ayuda_imagen){
            ayuda = 0;
        } else {
            ayuda = 1;
        }
        let puntajeParcial;
        if(primero + segundo == 0) {
            puntajeParcial = 0
        } else {
            puntajeParcial = primero + segundo + ayuda;
        }
        newList[count-1].puntaje = puntajeParcial;
        newList[count-1].ayuda = ayuda;
        newList[count-1].ejemplo = 0;
        setResultado(newList);
        if(count < indexes) {
            setTimeout(() => {
                setDisable(false);
                setCount(count + 1);
                setActivoPrimero(false);
                setActivoSegundo(false);
                setElegiPrimero(false);
            }, 100);
        } else {
            setTimeout(() => {
                setDisable(false);
                dispatch( finalizarEjercicioAction() )
            }, 100);
        }
    }
    
    useEffect(() => {
        dispatch(setearEjercicioAction('SCR5') );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
        dispatch(resetearAyudaEstadoAction(true));
        const cantidad = informacion[count-1]?.cantidad_silabas;
        const newArray = Array.from({ length: cantidad }, (_, index) => ({ id: index + 1 }));
        setCirculos(newArray);
    }, [count, informacion])
    
    useEffect(() => {
        setResultado(resultadoBase);
    }, [informacion])

    useEffect(() => {
        if(finalizar ){
            const informacion = {
                config,
                payload: {
                    'screening': true,
                    'ejercicio': "SCR5",
                    'resultado': resultado,
                    'id_paciente': id_paciente
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} ayuImagen={true} />
            {iniciar
                ?
                <ContainerFlex display="flex" direction="column" height="100%" width="100%">
                    {comparar.ejemplo ? 
                    <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                        Ejemplo
                    </Flex>
                    : null
                    }
                    <ContainerFlex display="flex" align="center" justify="center" margin="auto" direction="column">
                        <ContainerFlex>
                            <Img align="center" justify="center" src={`/img/${comparar.imagen_url_1}.png`} width="15vw" widthmob="20vw" />
                        </ContainerFlex>
                        {ayuda_imagen ? 
                        <ContainerFlex display="flex" margin="0.5rem 0 0 0">
                            {circulos.map(obj => (
                                <div
                                    key={obj.id}
                                >
                                    <Circulo></Circulo> 
                                </div>
                            ))}
                        </ContainerFlex>
                        : null 
                        }
                    </ContainerFlex>

                    <ContainerFlex display="flex" justify="space-between" justifyself="end" margin="0 0 0.5rem 0">
                        <ContainerFlex>
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        </ContainerFlex>
                        <ContainerFlex display="flex">
                            <ContainerFlex display="flex" margin ="0 2rem 0 0">
                                <Cuadrado backgroundColor="#E7973C" margin="0 0.3rem 0 0" style={{border: activoPrimero ? "4px solid yellow" : "none"}}
                                disabled={disable}
                                onClick={(e) => elijo(e, 1)}
                                ></Cuadrado>
                                <Cuadrado backgroundColor="#646464" style={{border: activoSegundo ? "4px solid yellow" : "none"}}
                                disabled={disable}
                                onClick={(e) => elijo(e, 2)}
                                ></Cuadrado>
                            </ContainerFlex>
                            <ContainerFlex display="flex" margin ="0 1rem 0 0">
                                <Cuadrado backgroundColor="#5DEBC9"  margin="0 0.3rem 0 0"
                                disabled={disable}
                                onClick={(e) => verifico(e, 3)}
                                ></Cuadrado>
                                <Cuadrado backgroundColor="#646464" 
                                disabled={disable}
                                onClick={(e) => verifico(e, 4)}
                                ></Cuadrado>
                            </ContainerFlex>
                        </ContainerFlex>
                    </ContainerFlex>
                </ContainerFlex>
                :
                <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default SCR5;